import { NeutralColors } from '@picsart/design-system/foundation/colors';

import { IconShare } from '@picsart/design-system/foundation/icons/IconShare';
import { Popup } from '@picsart/design-system/components/Popup';

import ShareButtons from 'components/ShareButtons';
import testIds from './testIds';
import { ANALYTICS_NAMES } from '../../constants';

import useTemplateStyles from './style';
import { ShareProps } from './type';

const TemplateShareButton = ({
  controlledExampleIsVisible,
  handlePopUpClick,
  imageViewPageUrl,
  handleShareClick,
  className,
}: ShareProps) => {
  const classes = useTemplateStyles();

  return (
    <div
      data-testid={testIds.root}
      data-pulse-name={ANALYTICS_NAMES.TEMPLATE_SHARE_BUTTON}
      data-pulse-clickable="true"
    >
      <Popup isShown={controlledExampleIsVisible} zIndex={10} onClose={handlePopUpClick}>
        <ShareButtons className={classes.shareButtons} imageViewPageUrl={imageViewPageUrl} />
      </Popup>
      <div className={classes.popupButton}>
        <div
          className={
            className === 'slider' ? classes.shareSliderWrapper : classes.asideShareSliderWrapper
          }
        >
          <IconShare fill={NeutralColors.text.default} onClick={handleShareClick} />
        </div>
      </div>
    </div>
  );
};

export default TemplateShareButton;
